import { useCurrentUser } from './useApi';

export const useUserPermissions = () => {
  // Use the useCurrentUser hook which already fetches from /api/general/me
  // This ensures we share the same cache and avoid duplicate API calls
  const { data, isLoading, error } = useCurrentUser();

  const hasPermission = (permission: string): boolean => {
    if (!data?.permissions) return false;
    return data.permissions.includes(permission);
  };

  const hasRole = (roleName: string): boolean => {
    if (!data?.roles) return false;
    return data.roles.some(role => role.name === roleName);
  };

  return {
    userProfile: data,
    permissions: data?.permissions || [],
    roles: data?.roles || [],
    isLoading,
    error,
    hasPermission,
    hasRole,
    hasStorePrivileged: hasPermission('store.privileged'),
  };
};